import { render, staticRenderFns } from "./SettingsCurrencies.vue?vue&type=template&id=3f559d41&"
import script from "./SettingsCurrencies.vue?vue&type=script&lang=js&"
export * from "./SettingsCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCurrencies.vue?vue&type=style&index=0&id=3f559d41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports